<template>
  <b-container fluid class="p-0">
    <b-navbar class="top-navbar p-1" variant="white">
      <b-container class="px-3">
        <b-navbar-nav class="navbar-left-item mt-2 ml--10">
          <b-nav-item :to="{ name: 'job.feed-page' }" class="top-navbar-title">
            <b-img
              rounded
              alt="Logo"
              width="250"
              :src="require('@/assets/images/logo_horizontal.png')"
            ></b-img>
          </b-nav-item>
        </b-navbar-nav>

        <b-navbar-nav class="navbar-right-item" right>
          <b-nav-item-dropdown
            id="my-nav-dropdown"
            block
            no-caret
            link
            right
            class="mr--10"
            menu-class="nav-option-list"
            @show="show = true"
            @hide="show = false"
          >
            <template v-slot:button-content>
              <b-avatar
                variant="primary"
                :text="userInitials"
                class="font-weight-bold"
              ></b-avatar>
            </template>

            <b-dropdown-item
              :to="{ name: 'user.settings-page', params: { tab: 3 } }"
            >
              <span class="v-middle">My Account</span>
            </b-dropdown-item>

            <b-dropdown-item @click="signOut">
              <span class="v-middle">Logout</span>
            </b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-container>
    </b-navbar>

    <b-overlay
      id="overlay-background"
      :show="show"
      bg-color="black"
      opacity="0.5"
      blur="none"
      spinner-type
    >
      <div class="slot-container p-0 m-0 full-width">
        <slot />
        <footer-section />
      </div>
    </b-overlay>
  </b-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import FooterSection from '@/components/FooterSection'
import firebase from 'firebase/app'
import 'firebase/firebase-messaging'

export default {
  components: {
    FooterSection
  },

  computed: {
    ...mapState({
      user: state => state.auth.user,
      device: state => state.device.deviceDetails
    }),

    userInitials() {
      if (this.user && this.user.full_name) {
        const initials = this.user.full_name.split(' ')
        return `${initials[0][0]}${
          initials[initials.length - 1][0]
        }`.toUpperCase()
      } else {
        return ''
      }
    }
  },

  data() {
    return {
      show: false
    }
  },

  methods: {
    ...mapActions({
      logout: 'auth/logout',
      getAuthenticatedUser: 'auth/getAuthenticatedUser',
      storeDeviceDetails: 'device/storeDeviceDetails'
    }),

    signOut() {
      if (window.gapi) {
        window.gapi.auth2.getAuthInstance().signOut()
      }
      if (window.FB) {
        window.FB.logout()
      }
      this.logout()
    },

    async cloudMessaging() {
      // Retrieve an instance of Firebase Messaging so that it can handle background
      // messages.
      const messaging = firebase.messaging()

      messaging.getToken().then(currentToken => {
        if (currentToken) {
          this.storeDeviceDetails(currentToken)
        } else {
          // Show permission request.
          // console.log(
          //   'No Instance ID token available. Request permission to generate one.'
          // )
        }
      })
      // .catch(err => {
      //   console.log('An error occurred while retrieving token. ', err)
      // })
    }
  },

  async created() {
    await this.getAuthenticatedUser()
    await this.cloudMessaging()
  }
}
</script>

<style scoped lang="scss">
.top-navbar {
  position: fixed;
  width: 100%;
  z-index: 99;
}
.navbar-expand .navbar-nav .nav-link {
  padding: 0;
}
.slot-container {
  height: 100%;
}
.nav-button {
  margin-top: 4px;
  height: 36px;
}
.ml--10 {
  margin-left: -10px;
}
.mr--10 {
  margin-right: -10px;
}
// @media (max-width: 576px) {
//   .slot-container {
//     padding-right: 15px !important;
//     padding-left: 15px !important;
//   }
// }
</style>
